<div class="cart-alliance content-without-footer d-flex">
    <app-cart
        [titleCustomFees]="titleCustomFees"
        [convenienceFees]="convenienceFees"
        [customSubtotal]="customSubtotal"
        [customSubtotalTitle]="customSubtotalTitle"
        [cartNote]="cartNote"
        class="position-absolute"
    >
    </app-cart>
</div>
